import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { NgModule } from '@angular/core';
import { MyUserNotificationsComponent } from './myusernotifications.component';
import { AddEditNotificationsModule } from './add.edit.notifications/addeditnotifications.module';
import { PcpCommandBarModule } from '../../../pcpcommandbar/pcp-commandbar.module';

@NgModule({
    imports: [AddEditNotificationsModule,
        CommonModule,        
        PcpCommandBarModule,
        TableModule, MyUserNotificationsComponent],
    exports: [MyUserNotificationsComponent]
})
export class MyUserNotificationsModule { }
